import { styled } from 'styled-components';

import type { Color } from '#/theme/theme';
import { colors, fontWeights } from '#/theme/theme';

const InitialsContainer = styled.div<{ $round: boolean | undefined }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.selectionGrey};
  font-size: 64px;
  font-weight: ${fontWeights.bold};
  text-align: center;
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  border-radius: ${(props) => (props.$round ? '100%' : undefined)};
`;

type Props = {
  name: string | undefined;
  size: number;
  round?: boolean;
  backgroundColorName?: Color;
};

export function Initials({ name, size, round, backgroundColorName }: Props) {
  // We use [...name][0] because the first letter may be an emoji and
  // name[0] returns only part of the emoji, producing and invalid utf8 character
  const firstLetter = name ? [...name][0] : '';

  return (
    <InitialsContainer
      $round={round}
      style={{
        maxWidth: size || '100%',
        maxHeight: size || '100%',
        background: backgroundColorName
          ? colors[backgroundColorName]
          : undefined,
      }}
    >
      {firstLetter}
    </InitialsContainer>
  );
}
